import { useEffect, useState, useCallback } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch } from "react-redux";
import Calendar from "./Calendar";
import Footer from "./Footer";
import Gallery from "./Gallery";
import Header from "./Header";
import OurStory from "./OurStory";
import { Helmet } from "react-helmet-async";
import "../../../scss/Wedding/style.css";
import "../../../scss/Wedding/ql.css";
import "../../../scss/bootstrap.min.css";
import { getWeddingWebsiteData } from "../../../redux/rsvpSlice.js";
import { getFontList } from "../../../redux/pdfSlice";
import { configureFonts } from "./fontUtils"

function Main() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState(true);

  let { rsvpCode } = useParams();
  if (rsvpCode===undefined) rsvpCode="_";

  const getFonts = async () => {
    configureFonts(await dispatch(getFontList()));
  }
  useEffect(getFonts, [dispatch]);

  const handleChange = useCallback(async() => {
    const res = await dispatch(getWeddingWebsiteData(rsvpCode));
    console.log(res);
    if (res?.payload?.couple) {
      res.payload.owner = false;
      setDetails(res.payload);
      const ww = res.payload.couple.wedding_website;
      document.documentElement.style.setProperty('--shiv-ww-pageColor', ww.pageColor || "#5ce1e6");
      document.documentElement.style.setProperty('--shiv-ww-titleFont', ww.titleFont || "Lato, sans-serif");
      document.documentElement.style.setProperty('--shiv-ww-detailsFont', ww.detailsFont || "Lato, sans-serif");
      setLoading(false);
    }
  }, [dispatch, rsvpCode]);

  useEffect(() => {
    handleChange();
  }, [handleChange]);


  const getURL = (targetName, backupImg) => {
    var result = backupImg;
    if (Array.isArray(details?.images)) {
      const r=details.images.filter(img=>img.name===targetName);
      if (r.length>0) {
        result=r[0].url;
      }
    }
    return result;
  }

  const header = <Helmet>
  <meta charSet="utf-8" />
  <meta
    name="description"
    content="Your personal SHIV Wedding Website to showcase all your selected ceremony invitation details to your guests. Use our secure passcode for safe viewing of all your Wedding Ceremonies."
  />

  <title>Wedding Invitations &amp; RSVP Platform</title>
</Helmet>

  if (loading) return <>
    {header}
  </>

  return (
    <>
      {header}
      <div className="wedding_website">
        <Header details={details} />
        <Calendar details={details} getURL={getURL} />
        <OurStory details={details} />
        <Gallery details={details} onChange={handleChange} />
        <Footer />
      </div>
    </>
  );
}

export default Main;
